import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTiktokLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 11.84a9.847 9.847 0 0 1-5.756-1.842v8.382a7.623 7.623 0 0 1-13.372 5.002 7.623 7.623 0 0 1 6.8-12.555v4.215a3.497 3.497 0 1 0 2.447 3.338V2h4.125c-.003.349.027.697.089 1.04a5.73 5.73 0 0 0 2.526 3.76 5.69 5.69 0 0 0 3.141.943v4.097Z" />
  </svg>
);
export default SvgTiktokLogo;
